function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <main className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold mb-4">Cloudflare Boilerplate</h1>
        <p className="text-muted-foreground">
          Pronto para desenvolvimento com React + Cloudflare Pages + Workers + D1
        </p>
      </main>
    </div>
  )
}

export default App
